import React from 'react';
import { useIntl } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';

import { RowPropType } from '../../../../../prop-types/react-table';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import messages from '../messages';
import style from '../style.module.less';

const RowSelectionColumnId = 'isSelected';

const RowSelectionCell = ({ row }) => {
  const { name, sku } = row.original.itemName || {};
  const { checked, indeterminate } = row.getToggleRowSelectedProps?.() || {};

  const intl = useIntl();
  const ariaLabel = intl.formatMessage(messages.rowSelectionAriaLabel, {
    name,
    sku,
  });

  return <Checkbox ariaLabel={ariaLabel} checked={checked} indeterminate={indeterminate} onChange={row.toggleRowSelected} />;
};

RowSelectionCell.propTypes = {
  row: RowPropType.isRequired,
};

const createRowSelectionColumnDefinition = createColumnDefinitionBuilder({
  accessor: RowSelectionColumnId,
  Cell: RowSelectionCell,
  width: 0,
  className: style['justify-center'],
});

export { RowSelectionColumnId, createRowSelectionColumnDefinition };
